import React from 'react'
import Head from 'next/head'
import useFacebook from '../../hooks/useFacebook'
import useTagboard from '../../hooks/useTagboard'
import renderHtml, { sanitizedHtml } from '../../utils/renderHTML'
import style from '../../styles/components/story/story-body'

const hasElement = ({ html, name }) => {
  return html?.indexOf(name) !== -1
}

const StoryBody = ({ story }) => {
  const html = story?.html?.body || story?.html?.content
  useFacebook(hasElement({ html, name: 'facebook-embed' }))
  useTagboard(hasElement({ html, name: 'tagboard-embed' }))

  let bodyContent
  if (story?.html?.content) {
    bodyContent = story?.html?.content
  } else if (story?.html?.body) {
    bodyContent = story?.html?.body
  } else {
    bodyContent = `<p>${story.description}</p>`
  }

  return (
    <>
      {(story?.html?.body || story?.html?.content) && (
        <Head>
          <meta name='twitter:dnt' content='on' />
          <script async src='https://platform.twitter.com/widgets.js' charSet='utf-8'></script>
        </Head>
      )}
      {renderHtml(sanitizedHtml(bodyContent))}
      <style jsx global>
        {style}
      </style>
    </>
  )
}

export default StoryBody
